export default {
    
    post641568f1b6f87: '/641568f1b6f87', //Э��
    post691552dae8cdb: '/691552dae8cdb', //��Ƶ�б�
    post6915578674d9d: '/6915578674d9d', //��Ƶ����
    post691305f481f5b: '/691305f481f5b', //��ѯ������Ƭ
    post691307e2d1323: '/691307e2d1323', //¼����Ϣ
    post691546a0ba6fe: '/691546a0ba6fe', //��Ƭ����
    post691ec294cc358: '/691ec294cc358', //��Ʒ����
    post691ae1bbbdba8: '/691ae1bbbdba8', //Ʒ��
	
    post64cdb895b79ba: '/64cdb895b79ba', //��������
    post64219a95b6200: '/64219a95b6200', //�����뷴��
    post64219c5dc8d0d: '/64219c5dc8d0d', //��ȡ��������
    post6414719bdc956: '/6414719bdc956', //�����������
    post6414724b96f3f: '/6414724b96f3f', //��������ύ
    post641472eb35317: '/641472eb35317', //���������¼
	
    post5c78dbfd977cf: '/5c78dbfd977cf', //�˺������¼
    post6668f5d1d434e: '/6668f5d1d434e', //��¼ע��-�����֤�뻷��
    post666a45d4d6bb4: '/666a45d4d6bb4', //��¼ע��-������֤��-��ȫУ��
    post5caeeba9866aa: '/5caeeba9866aa', //��¼ע��-�������루�������룩
    post5c78c4772da97: '/5c78c4772da97', //��������
    post5cb54af125f1c: '/5cb54af125f1c', //�޸ĸ�������
    // post691c45b4d8bec: '/691c45b4d8bec', //��֤ͼƬ
    post691d8238c8328: '/691d8238c8328', //�����֤ͼƬ
    post691d8833217bb: '/691d8833217bb', //��ҳ����
	  
	
	
}
